import styled from "styled-components";
import { media, theme } from "../../theme/theme";

export const LCN_MOBILE_SEARCH_BR = 580;

export const LCNBarWrapper = styled.div<{ $searchFocused: boolean, $skipWrapperPadding: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: ${({ $skipWrapperPadding }) => !$skipWrapperPadding ? "8px 18px" :  "0px"}; 

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        padding: ${({ $skipWrapperPadding }) => !$skipWrapperPadding ? "14px 18px;" : "0px"}; 
    }

    > div {
        &:first-child {
            display: ${({ $searchFocused }) => $searchFocused ? "none" : "block"};
        }

        width: ${({ $searchFocused }) => $searchFocused ? "100%" : undefined};
    }
`;

export const LCNLabelWrapper = styled.div<{ $isLabelString: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: ${({ $isLabelString }) => $isLabelString ? "flex-end" : "center"};
    position: static;
    top: initial;

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        > * {
            &:first-child {
                margin-right: ${({ theme }) => `${theme.v3.spacings.spacing3}px`};
            }

            &:not(:first-child) {
                margin-bottom: ${({ $isLabelString }) => $isLabelString ? "4px" : undefined};
            }
        }
    }
`;

export const LCNFilterControls = styled.div<{ $searchFocused: boolean }>`
    display: flex;
    align-items: center;

    > div {
        width: ${({ $searchFocused }) => $searchFocused ? "100%" : undefined};

        &:first-child {
            display: ${({ $searchFocused }) => $searchFocused ? "none" : "block"};

            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                display: none;
            }
        }
    }
`;

export const LCNFilterIconToggle = styled.div`
    display: flex;
    align-items: end;

    &:hover {
        cursor: pointer;
    }

    > div {
        &:first-child {
            display: inline-flex;
            margin-right: ${({ theme }) => `${theme.v3.spacings.spacing2}px`};
        }
    }
`;

export const LCNSearchCreateWrapper = styled.div<{ $searchFocused: boolean }>`
    display: flex;
    align-items: center;

    > div {
        flex-shrink: 0;

        &:first-child {
            display: none;

            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                display: block;
            }
        }

        &:nth-child(2) {
            margin-left: ${({ $searchFocused }) => $searchFocused ? "0" : "18px"};
            width: 100%;
            max-width: ${({ $searchFocused }) => $searchFocused ? "550px" : "145px"};

            ${media.custom(LCN_MOBILE_SEARCH_BR)} {
                max-width: initial;
                width: 270px
            }
        }
    }
`;

export const LSPDesktopFilterPanel = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 18px;
`;